export default __webpack_public_path__ + "static/media/usuarios.53f401c2.svg";